import {Fragment, useEffect, useMemo, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import allBuildings from "../../../images/newDesign/all_buildings.svg";
import dollar from "../../../images/newDesign/dollar.svg";
import calendar from "../../../images/newDesign/Calendar.svg";
import { MenuNavItem } from "../../sidebar/MenuNavItem";
import MaintenanceSidebarMenu from "./maintenanceSidebarMenu";
import { constants, developerInterestEmail } from "../../../common/constants/constants";
import { toggleMobileMenuOpened } from "../../../store/common/slice";
import withdrawal from "../../../images/newDesign/withdrawal.svg";
import {hasPremiumAccessSelector, isAdminSelector} from "../../../store/auth/selectors";
import maintenance from "../../../images/newDesign/maintenance.svg";
import homeIcon from "../../../images/newDesign/homeIcon.svg";
// import managerAi from "../../../images/newDesign/manager.svg";
import legalDocumentIcon from "../../../images/newDesign/legal_document.svg";
import ServerData from "../../../common/serverData";
import {UtilsApi} from "../../../../client/tenants/utils.api";
import {useAccessToken} from "../../../common/hooks/useAccessToken";

const maintenanceByPartner = new Map();
import ConfirmLawyerLetterModal from "./ConfirmLawyerLetterModal";
import ResultLawyerLetterModal from "./ResultLawyerLetterModal";

/**
 * @param {string} buildingId
 * @param {boolean} isGreenInvoiceOn
 * @return {JSX.Element}
 * @constructor
 */
export default function PartnerSidebarGroup({ buildingId, isGreenInvoiceOn }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const client = useAccessToken();
    const userProfile = useSelector((state) => state.auth.userProfile);
    const partnerId = useSelector((state) => state.auth.userProfile?.partnerID);
    const isPremiumUser = useSelector(hasPremiumAccessSelector);
    const isAdmin = useSelector(isAdminSelector);
    const managerAllBuildings = useSelector(state => state.manager.buildings?.buildings);
    // const managerAllBuildings = useSelector(state => state.manager.buildings?.buildings ?? []);
    // const managerAllBuildingsActive = managerAllBuildings.filter(b=> !b.disabled);
    const [isBllinkMaintenanceActiveAtLeastForOneBuilding, setIsBllinkMaintenanceActiveAtLeastForOneBuilding] = useState(false);
    // const managerAllBuildingsCount = managerAllBuildingsActive.length;
    //https://bllink.atlassian.net/browse/SSB-1544
    // const MIN_BUILDINGS_TO_GET_LEAD_OFFER = 20;
    // const shouldShow = userProfile?.partnerID && managerAllBuildings && managerAllBuildingsCount > 0 && managerAllBuildingsCount < MIN_BUILDINGS_TO_GET_LEAD_OFFER;
    const [showConfirmLawyerLetterModal, setShowConfirmLawyerLetterModal] = useState(false);
    const [showResultLawyerLetterModal, setShowResultLawyerLetterModal] = useState(false);
    const [lawyerLetterLoading, setLawyerLetterLoading] = useState(false);
    const maintenanceChecked = useRef(false);

    useEffect(() => {
        if (maintenanceChecked.current) return;
        const allBuildings = managerAllBuildings ?? [];
        if (!client?.managers?.features?.getFeatureForEntitys || allBuildings.length === 0) return;

        maintenanceChecked.current = true;
        (async () => {
            if (maintenanceByPartner.has(partnerId)) {
                setIsBllinkMaintenanceActiveAtLeastForOneBuilding(maintenanceByPartner.get(partnerId));
                return;
            }
            const list = allBuildings.map((b) => ({
                entityType: "buildingID",
                entityId: b.buildingID,
                featureName: "bllinkMaintenance",
            }));
            const res = await client.managers.features.getFeatureForEntitys(list);
            const result = res.some((item) => item && item?.value === "true");
            maintenanceByPartner.set(partnerId, result);
            setIsBllinkMaintenanceActiveAtLeastForOneBuilding(result);
        })();
    }, [managerAllBuildings, Boolean(client?.managers?.features?.getFeatureForEntitys)]);

    const closeSidebarOnMobileClick = () => {
        dispatch(toggleMobileMenuOpened())
    }

    const sendInternalEmailAndContinue = async () => {
        const client = new ServerData();
        const query = ``;
        const params = {
            sendTo: [...developerInterestEmail, "rayee@bllink.co"],
            title: `referral menu button pressed ${userProfile?.userID}`,
            content: `
                pressed by ${userProfile?.userID} from ${userProfile?.partnerName || 'no partner name'}
            `,
        };
        const utilsApi = new UtilsApi(client);
        await utilsApi.postInternalEmail(constants.backendEndpoints.GENERIC_INTERNAL_EMAIL_ENDPOINT, query, params);

        closeSidebarOnMobileClick()
    }

    const partnerProfileUrl = useMemo(() => {
        return isPremiumUser ? `/${constants.pages.partnerProfilePage}/${userProfile?.partnerID}` : `/${constants.pages.premiumInfoPage}`
    }, [userProfile, isPremiumUser])

    const handleLegalDocumentClick = () => {
        setShowConfirmLawyerLetterModal(true);
        closeSidebarOnMobileClick();
    };

    const handleLegalDocumentConfirm = async () => {
        if (userProfile) {
        setLawyerLetterLoading(true);
          const query = ``;
          const params = {
            sendTo: ["omri@bllink.co"],
            title: `New Lawyer Letter Request`,
            content: `New Lawyer Letter Request, name: ${userProfile?.userFirstName}, buildingId: ${buildingId}, email: ${userProfile?.userID}, phone: ${userProfile?.phone}, partnerName: ${userProfile?.partnerName}, partnerID: ${userProfile?.partnerID}`,
          };
          const utilsApi = new UtilsApi(client);
          await utilsApi.postInternalEmail(constants.backendEndpoints.GENERIC_INTERNAL_EMAIL_ENDPOINT, query, params);
          setShowConfirmLawyerLetterModal(false);
          setShowResultLawyerLetterModal(true);
          setLawyerLetterLoading(false);
        }
    };

    const hideLegalDocumentModal = () => {
        setShowConfirmLawyerLetterModal(false);
    }

    const hideResultLawyerLetterModal = () => {
      setShowResultLawyerLetterModal(false);
    };

    return (
        <Fragment>
            {/* requested by rayee via email*/}
            {/*<MenuNavItem*/}
            {/*    icon={products_at_discount}*/}
            {/*    url={`/${constants.pages.marketPlace}`}*/}
            {/*    onClick={closeSidebarOnMobileClick}*/}
            {/*    label={t('buildings.nav_bar_products_at_a_discount')}*/}
            {/*/>*/}
            {userProfile?.partnerID && isAdmin ? <MenuNavItem
                icon={maintenance}
                url={partnerProfileUrl}
                onClick={closeSidebarOnMobileClick}
                label={t('buildings.nav_bar_partner_profile')}
            /> : null }
            {/* maybe show this only after a week or 2 logins to bllink userProfile.createdAt*/}
            {userProfile?.isDemoSignUpUser ? <MenuNavItem
                icon={homeIcon}
                url={`/${constants.pages.selfOnBoard}`}
                onClick={closeSidebarOnMobileClick}
                tooltipDisabled={false}
                tooltip={t('buildings.nav_bar_demo_sign_up_real_building_tooltip')}
                label={t('buildings.nav_bar_demo_sign_up_real_building')}
            />  : null }


            {/* removing. omri confirmed verbally to remove*/}
            {/*<MenuNavItem*/}
            {/*    icon={homeIcon}*/}
            {/*    highlight={true}*/}
            {/*    url={`/${constants.pages.insuranceOfferUrl}`}*/}
            {/*    onClick={closeSidebarOnMobileClick}*/}
            {/*    tooltipDisabled={false}*/}
            {/*    tooltip={t('buildings.nav_bar_building_insurance_offer_tooltip')}*/}
            {/*    label={t('buildings.nav_bar_building_insurance_offer')}*/}
            {/*/>*/}

            {/* removed omri requested by email */}
            {/*<MenuNavItem*/}
            {/*        icon={homeIcon}*/}
            {/*        url={`/${constants.pages.serviceProviders}`}*/}
            {/*        onClick={closeSidebarOnMobileClick}*/}
            {/*        tooltipDisabled={false}*/}
            {/*        tooltip={t('buildings.nav_bar_additional_services_tooltip')}*/}
            {/*        label={t('buildings.nav_bar_additional_services')}*/}
            {/*    />*/}

            {/* <MenuNavItem
                icon={dollar}
                url={`https://rayee92.wixstudio.io/referral`}
                onClick={sendInternalEmailAndContinue}
                label={t('buildings.nav_bar_referral')}
                tooltip={t('buildings.upgrade_to_premium')}
                disabled={!isPremiumUser}
                tooltipDisabled={isPremiumUser}
            /> */}
            <MenuNavItem
                icon={calendar}
                url={`https://calendly.com/talv-bllink/meet-with-me`}
                onClick={closeSidebarOnMobileClick}
                tooltipDisabled={false}
                tooltip={t('buildings.nav_bar_schedule_call_tooltip')}
                label={t('buildings.nav_bar_schedule_call')}
            />
            <MenuNavItem
                icon={dollar}
                url={`https://app---7864cdee.base44.app/`}
                onClick={closeSidebarOnMobileClick}
                tooltipDisabled={false}
                tooltip={t('buildings.nav_bar_external_collection_tooltip')}
                label={t('buildings.nav_bar_external_collection')}
            />
            
            <MenuNavItem
                icon={dollar}
                url={`https://app--100-e20b4a85.base44.app/`}
                onClick={closeSidebarOnMobileClick}
                tooltipDisabled={false}
                tooltip={t('buildings.nav_bar_100_percent_track_tooltip')}
                label={t('buildings.nav_bar_100_percent_track')}
            />
            <MenuNavItem
                icon={withdrawal}
                url={`/${constants.pages.fundsEarlyTransferUrl}`}
                onClick={closeSidebarOnMobileClick}
                label={t('buildings.nav_bar_funds_early_transfer')}
                tooltip={t('buildings.upgrade_to_premium')}
                disabled={!isPremiumUser}
                tooltipDisabled={isPremiumUser}
            />
            {/*requested by rayee as experiment*/}
            {/* {(!userProfile?.partnerID || isAdmin) ?
                <MenuNavItem
                    icon={managerAi}
                    url={`https://airtable.com/app5s2dvUOqrQMGoA/pagRxwB3laGEiXhGM/form` }
                    onClick={closeSidebarOnMobileClick}
                    label={t('buildings.nav_bar_professionals')}
                    tooltip={t('buildings.price_offer_tooltip')}
                    tooltipDisabled={false}
                /> : null} */}

            {(isBllinkMaintenanceActiveAtLeastForOneBuilding || isAdmin) && (
                <MenuNavItem
                    icon={maintenance}
                    url={`https://maintenance.bllink.co/Identification`}
                    onClick={closeSidebarOnMobileClick}
                    label={t('buildings.nav_bar_maintenance')}
                    tooltip={t('buildings.nav_bar_maintenance')}
                    tooltipDisabled={false}
                />
            )}
            
            {/*https://bllink.atlassian.net/browse/SSB-1689 */}
            {userProfile?.isViewOnly ? null : <MaintenanceSidebarMenu buildingId={buildingId}/>}
            {userProfile?.partnerID ?
                <MenuNavItem
                    icon={allBuildings}
                    url={`/${constants.pages.buildingManagerCompanyProfileUrl}/${userProfile.partnerID}` }
                    onClick={closeSidebarOnMobileClick}
                    label={t('buildings.nav_bar_all_buildings_data')}
                    tooltip={t('buildings.upgrade_to_premium')}
                    disabled={!isPremiumUser}
                    tooltipDisabled={isPremiumUser}
                /> : null}

            {/*requested by rayee*/}
            {/*{shouldShow ? <MenuItem*/}
            {/*    icon={<img src={leadOffer} alt="lead offer page"/>}*/}
            {/*    active={isLinkActive(`/${constants.pages.partnerLeadPage}/${userProfile.partnerID}`)}*/}
            {/*    onClick={closeSidebarOnMobileClick}>*/}
            {/*    <NavLink*/}
            {/*        className="nav-link"*/}
            {/*        to={`/${constants.pages.partnerLeadPage}/${userProfile.partnerID}`}>*/}
            {/*        {t('buildings.nav_bar_new_leads')}*/}
            {/*    </NavLink>*/}
            {/*</MenuItem> : null}*/}

            <MenuNavItem
                icon={legalDocumentIcon}
                url={`#`}
                onClick={handleLegalDocumentClick}
                label={t('buildings.nav_bar_lawyer_letter')}
                tooltip={t('buildings.nav_bar_lawyer_letter')}
                tooltipDisabled={false}
            />

            <ConfirmLawyerLetterModal
                show={showConfirmLawyerLetterModal}
                onModalHide={hideLegalDocumentModal}
                onConfirm={handleLegalDocumentConfirm}
                isLoading={lawyerLetterLoading}
            />
            <ResultLawyerLetterModal
                show={showResultLawyerLetterModal}
                onModalHide={hideResultLawyerLetterModal}
            />
        </Fragment>
    );
}
